import { render, staticRenderFns } from "./szTable.vue?vue&type=template&id=5596fdca&scoped=true"
import script from "./szTable.vue?vue&type=script&lang=js"
export * from "./szTable.vue?vue&type=script&lang=js"
import style0 from "./szTable.vue?vue&type=style&index=0&id=5596fdca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596fdca",
  null
  
)

export default component.exports